import React from "react";

function Experience() {
  return (
    <div>
      {/* Frontier Software */}
      <h3>Frontier Software: Senior Development Manager, Payroll Software Company</h3>
      <p>2023 – Present</p>
      <ul>
        <li>
          <strong>Leadership & Team Management:</strong> Oversee multiple
          cross-functional teams (Release, Scrum Masters, DevOps, Project
          Management, Data Analytics, Testing), supporting 20 product teams
          throughout the SDLC
        </li>
        <li>
          <strong>Strategic Process Optimisation:</strong> Aligned technology
          practices with broader organisational objectives, introducing
          automated quality checks and agile methods to shorten development
          lifecycles and improve customer satisfaction
        </li>
        <li>
          <strong>Data-Driven Improvements:</strong> Led automation of client
          issue tracking and standardised reporting across departments, reducing
          client issues by 30% and halving resolution times within two months
        </li>
        <li>
          <strong>Staff Engagement & Collaboration:</strong> Introduced biannual
          town halls, monthly retrospectives, and department showcases,
          improving employee engagement and overall deliverable quality
        </li>
        <li>
          <strong>Business Process Automation:</strong> Cut a critical path task
          from three days to two hours through pipeline automation, freeing
          staff for higher-value tasks
        </li>
        <li>
          <strong>Roadmapping & Alignment:</strong> Formalised roadmaps to guide
          technology initiatives, ensuring alignment with annual financial
          objectives and stakeholder expectations
        </li>
        <li>
          <strong>Data Analytics Enablement:</strong> Established a dedicated
          Data Team, enabling executive decision-makers to rely on accurate,
          up-to-date data insights
        </li>
        <li>
          <strong>Vendor & Third-Party Management:</strong> Oversaw a platform
          migration project, handling scope definition, budgeting, and
          stakeholder sign-off, while meeting quality benchmarks
        </li>
        <li>
          <strong>Release Process Transformation:</strong> Automated software
          releases on a global scale, reducing errors and achieving a 10%
          decrease in client-reported issues
        </li>
        <li>
          <strong>Domain Consolidation & Cost Reduction:</strong> Streamlined
          domains and reused existing licences to cut SaaS vendor fees by 20%
        </li>
        <li>
          <strong>DevOps & Security:</strong> Introduced Kanban boards and
          shift-left security scanning, including an internal penetration
          testing function, to mitigate risks and enhance collaboration
        </li>
        <li>
          <strong>Serverless Infrastructure:</strong> Designed and implemented
          serverless solutions, expediting productivity and improving the
          customer experience
        </li>
      </ul>

      {/* Littlepay */}
      <h3>Littlepay: Engineering Manager, Fintech Startup</h3>
      <p>2021 – 2023</p>
      <ul>
        <li>
          <strong>Global Team Expansion:</strong> Oversaw five engineering teams
          and launched three new global teams, growing the engineering
          organisation to over 40 full-time engineers
        </li>
        <li>
          <strong>Leadership & Mentorship:</strong> Recruited and mentored team
          managers, and implemented an engineering behaviours framework to guide
          career development
        </li>
        <li>
          <strong>Efficiency & Reporting:</strong> Deployed Linear B to improve
          engineering efficiency and visibility, giving senior stakeholders
          real-time insights into project progress
        </li>
        <li>
          <strong>Vendor Management:</strong> Selected and managed two vendors
          for mission-critical projects, ensuring timely deliverables and
          enabling internal staff to focus on other high-value initiatives
        </li>
        <li>
          <strong>AWS Serverless Migration:</strong> Transitioned legacy
          solutions (Kafka on EC2) to AWS SNS/SQS, reducing security risk and
          lowering operational costs
        </li>
        <li>
          <strong>Continuous Quality Automation:</strong> Established CI/CD
          automation running hourly to detect failures in critical services,
          enabling multiple deployments to production per day
        </li>
      </ul>

      {/* IAG (Multiple Roles) */}
      <h3>Insurance Australia Group (IAG)</h3>

      <h4>Software Engineering Lead (2020 – 2021)</h4>
      <ul>
        <li>
          <strong>Accelerator Business Leadership:</strong> Joined an internal
          disruptor program to enhance a cloud-based end-to-end Motor Insurance
          platform
        </li>
        <li>
          <strong>Cloud, Technical & Risk Governance:</strong> Oversaw
          governance and compliance (CPS234, CPS235), ensuring workloads
          deployed on time, within budget, and aligned with APRA regulations
        </li>
        <li>
          <strong>Cloud Data Lake Implementation:</strong> Led a cross-divisional
          team of ten to establish Snowflake as the first enterprise-wide cloud
          data lake, enabling real-time data-driven decisions
        </li>
        <li>
          <strong>Integration & Automation:</strong> Connected JIRA issue
          tracking with ServiceNow, reducing administrative overhead and
          streamlining risk management
        </li>
        <li>
          <strong>Monitoring & Alerting:</strong> Integrated New Relic for
          production alerts, speeding up incident resolution and reducing
          customer impact
        </li>
        <li>
          <strong>Performance Optimisation:</strong> Improved response times on
          the Rollin Insurance website, increasing customer engagement by 25%
        </li>
      </ul>

      <h4>Cloud Adoption Manager (2018 – 2020)</h4>
      <ul>
        <li>
          <strong>Enterprise-Wide Cloud Framework:</strong> Founded the Cloud
          Adoption team to help project teams transition workloads to the cloud,
          supporting over 40 concurrent workloads
        </li>
        <li>
          <strong>Compliance & Governance:</strong> Aligned cloud adoption with
          IAG Enterprise Standards (Risk, Data, Cyber, Operations), reducing the
          risk of non-compliance in regulated environments
        </li>
        <li>
          <strong>Reporting & Visibility:</strong> Devised a reporting structure
          for senior management to track activities within the Cloud Adoption
          Framework
        </li>
        <li>
          <strong>Vendor Collaboration:</strong> Worked with cloud providers to
          optimise product integration, accelerating time-to-market
        </li>
        <li>
          <strong>Operational Innovation:</strong> Established strategic
          workloads on AWS, SaaS, and Azure platforms, reducing capex and
          improving agility
        </li>
        <li>
          <strong>Reduced Delivery Times:</strong> Decreased cloud adoption
          timelines from nine months to under ten weeks by developing reusable
          technical patterns
        </li>
        <li>
          <strong>SaaS System of Record:</strong> Delivered IAG’s first
          SaaS-based System of Record for Poncho Insurance, streamlining
          processes and reducing overhead
        </li>
      </ul>
    </div>
  );
}

export default Experience;
